import {createSlice} from '@reduxjs/toolkit';

export interface AuthState {
    token: string | null;
    email: string | null;
    name: string | null;
    username: string | null;
    profilePic: string | null;
    phoneNumber: string | null;
    isOwner: boolean;
    permissions: any[];
    whatsapp?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    city?: string | null;
    state?: string | null;
    country?: string | null;
    zipCode?: string | null;
}

const initialState: AuthState = {
    token: null,
    email: null,
    name: null,
    username: null,
    profilePic: null,
    phoneNumber: null,
    isOwner: false,
    permissions: [],
    whatsapp: null,
    addressLine1: null,
    addressLine2: null,
    city: null,
    state: null,
    country: null,
    zipCode: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        loginSuccess(state, action) {
            state.token = action.payload.token;
            state.email = action.payload.email;
            state.name = action.payload.name;
            state.username = action.payload.username;
            state.profilePic = action.payload.profilePic;
            state.phoneNumber = action.payload.phoneNumber;
            state.isOwner = action.payload.isOwner;
            state.permissions = action.payload.permissions;
            state.whatsapp = action.payload.whatsapp;
            state.addressLine1 = action.payload.addressLine1;
            state.addressLine2 = action.payload.addressLine2;
            state.city = action.payload.city;
            state.state = action.payload.state;
            state.country = action.payload.country;
            state.zipCode = action.payload.zipCode;
            localStorage.setItem('token', action.payload.token);
        },
        refreshTokenSuccess(state, action) {
            state.token = action.payload.token;
            state.email = action.payload.email;
            state.name = action.payload.name;
            state.username = action.payload.username;
            state.profilePic = action.payload.profilePic;
            state.phoneNumber = action.payload.phoneNumber;
            state.isOwner = action.payload.isOwner;
            state.permissions = action.payload.permissions;
            state.whatsapp = action.payload.whatsapp;
            state.addressLine1 = action.payload.addressLine1;
            state.addressLine2 = action.payload.addressLine2;
            state.city = action.payload.city;
            state.state = action.payload.state;
            state.country = action.payload.country;
            state.zipCode = action.payload.zipCode;
            localStorage.setItem('token', action.payload.token);
        },
        refreshTokenFailed(state, action) {
            state.token = null;
            state.email = null;
            state.name = null;
            state.username = null;
            state.profilePic = null;
            state.phoneNumber = null;
            state.isOwner = false;
            state.permissions = [];
            state.whatsapp = null;
            state.addressLine1 = null;
            state.addressLine2 = null;
            state.city = null;
            state.state = null;
            state.country = null;
            state.zipCode = null;
            localStorage.removeItem('token');

        },
        logoutSuccess(state) {
            state.token = null;
            state.email = null;
            state.name = null;
            state.username = null;
            state.profilePic = null;
            state.phoneNumber = null;
            state.isOwner = false;
            state.permissions = [];
            state.whatsapp = null;
            state.addressLine1 = null;
            state.addressLine2 = null;
            state.city = null;
            state.state = null;
            state.country = null;
            state.zipCode = null;
            localStorage.removeItem('token');
        },
        profileUpdateSuccess(state, action) {
            state.email = action.payload.email;
            state.name = action.payload.name;
            state.phoneNumber = action.payload.phoneNumber;
            state.profilePic = action.payload.profilePic;
            state.username = action.payload.username;
            state.whatsapp = action.payload.whatsapp;
            state.addressLine1 = action.payload.addressLine1;
            state.addressLine2 = action.payload.addressLine2;
            state.city = action.payload.city;
            state.state = action.payload.state;
            state.country = action.payload.country;
            state.zipCode = action.payload.zipCode;
        },
    },
});

export const {
    loginSuccess,
    refreshTokenSuccess,
    refreshTokenFailed,
    logoutSuccess,
    profileUpdateSuccess,
} = authSlice.actions;
export default authSlice.reducer;
